import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { hc } from 'hono/client'
import type { AuthApi } from '@backend/auth'
import { apiFetch, FormError } from '@/lib/apiFetch'

type Store = ReturnType<typeof createStore>
const api = hc<AuthApi>('/api/auth', { fetch: apiFetch })

export const oldPasswordAtom = atom('')
export const newPasswordAtom = atom('')
export const isSubmittingAtom = atom(false)

export const submitAtom = atom(null, async (get, set) => {
  const oldPassword = get(oldPasswordAtom)
  const newPassword = get(newPasswordAtom)

  if (!oldPassword) throw new FormError('请输入旧密码')
  if (!newPassword) throw new FormError('请输入新密码')
  if (newPassword.length < 4) throw new FormError('新密码至少4位')

  set(isSubmittingAtom, true)
  try {
    const res = await api['change-password'].$post({ json: { oldPassword, newPassword } })
    if (!res.ok) {
      const body = await res.json().catch(() => ({ message: '修改失败' })) as { message?: string }
      throw new FormError(body.message || '修改失败')
    }
    return true
  } finally {
    set(isSubmittingAtom, false)
  }
})

export function loader(store: Store) {
  store.set(oldPasswordAtom, '')
  store.set(newPasswordAtom, '')
  store.set(isSubmittingAtom, false)
  return null
}
